import script from './component-lib.esm2.js';
import normalizeComponent from '../../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Card', _vm._g(_vm._b({
    staticClass: "v-notification-card",
    style: _vm.styles
  }, 'Card', Object.assign({}, _vm.cardPropsToBind, _vm.$attrs), false), _vm.$listeners), [_c('div', {
    staticClass: "v-notification-card__inner"
  }, [_vm.$slots.icon ? _c('div', {
    staticClass: "v-notification-card__icon"
  }, [_vm._t("icon")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-notification-card__content"
  }, [_vm.title ? _c('VText', {
    staticClass: "v-notification-card__title",
    attrs: {
      "variant": "h4",
      "color": _vm.textColor
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('VText', {
    staticClass: "v-notification-card__text",
    attrs: {
      "color": _vm.textColor
    }
  }, [_vm._v("\n        " + _vm._s(_vm.text) + "\n      ")]), _vm._v(" "), _vm.$slots.default ? _c('div', {
    staticClass: "v-notification-card__actions"
  }, [_vm._t("default")], 2) : _vm._e()], 1)]), _vm._v(" "), _vm.dismissable ? _c('span', {
    staticClass: "v-notification-card__dismiss"
  }, [_c('IconButton', _vm._b({
    attrs: {
      "color": _vm.textColor,
      "size": "1.25rem",
      "aria-label": "dismiss",
      "title": "dismiss"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('dismiss');
      }
    }
  }, 'IconButton', _vm.dismissProps, false), [_c('CloseIcon', {
    attrs: {
      "title": " "
    }
  })], 1)], 1) : _vm._e()]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-0e454600_0", {
    source: ".v-notification-card[data-v-0e454600]{color:var(--c-text-color);position:relative}.v-notification-card__inner[data-v-0e454600]{display:flex;gap:1rem;padding:1rem;padding-right:2rem}.v-notification-card__icon[data-v-0e454600]{font-size:1.5rem}.v-notification-card__content[data-v-0e454600]{display:flex;flex-direction:column}.v-notification-card__actions[data-v-0e454600]{display:flex;gap:.5rem;font-size:.925rem;margin-top:1rem}.v-notification-card__dismiss[data-v-0e454600]{display:block;position:absolute;top:.125rem;right:.125rem}.v-notification-card__title.v-notification-card__title[data-v-0e454600]{font-size:.825rem;margin-bottom:.5rem;opacity:.8}.v-notification-card__text.v-notification-card__text[data-v-0e454600]{font-size:.925rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-0e454600";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };